import { render } from "./SpinnerSvg.vue?vue&type=template&id=361c4d1f"
import script from "./SpinnerSvg.vue?vue&type=script&lang=js"
export * from "./SpinnerSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/ui/SpinnerSvg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "361c4d1f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('361c4d1f', __exports__)) {
    api.reload('361c4d1f', __exports__)
  }
  
  module.hot.accept("./SpinnerSvg.vue?vue&type=template&id=361c4d1f", () => {
    api.rerender('361c4d1f', render)
  })

}


export default __exports__